import type { FaireProductEntity } from "../../entity_types/product";

export const p_caymsb9trs: FaireProductEntity = {
  token: "p_caymsb9trs",
  type: "product",
  name: "Wholesale Discovery Kit - Eyes",
  brandToken: "b_3d2wzlqi",
  brandName: "River Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/6aaad7f5a0c3d6848423cd4dbd6726fca17125abb94cb1bd5f01f6d5429578fe.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c305327aaefac60cef6c723f1f30473b1ae5183b078724935c9e3110c677eb00.jpeg",
    "https://cdn.faire.com/fastly/355fa4376cd833a8d8b15c2fd72a6bbd816ceaeb898abd5bf7691a8752245916.jpeg",
    "https://cdn.faire.com/fastly/107415b2d9aeffff7060ccacd31f10a6b8773a3c23df81e38d41d193d2ff0ab8.png",
    "https://cdn.faire.com/fastly/961306d04ce6f60ecdb20bf206a45d9ab234e1cbcb306f470ed243ec09e1ee79.png",
    "https://cdn.faire.com/fastly/b5006321a48a1f70c1845eae70425b0a5e12dbc0008514c9184aa87cdb93678e.jpeg",
    "https://cdn.faire.com/fastly/0e456eaa612debfc51d6b0b07bcfaca7117a142e0dce635d16701a1229c2ef50.jpeg",
  ],
  priceDollars: 19.5,
  description:
    "Wholesale Discovery Kit at Tester Price - Please note we can only sell 1 kit per customer as this is to try the products out for future purchasing. \n\nDiscover our Eye collection, featuring cruelty-free, plant-based mascaras and brow waxes designed to define, shape, and nourish. Our natural mascaras provide voluminous, long-lasting lashes without harsh chemicals, while our brow waxes offer a flawless finish with growth-boosting ingredients. \n\nIn the kit: 1 Mascara + 2 Brow Waxes \n1 Black Mascara + Brush\n1 Brow Wax in Medium + Brush \n1 Brow Wax in Ash + Brush\n\n*Brow products will be back in stock soon!",
  tags: [],
  msrpDollars: 39,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:31.078Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
